import { resolveLabelFontSize } from '../../TextInput/TextInputStyles';
const resolveColor = (type, theme) => {
  if (type === 'error') {
    return theme.tokens.ComponentTextInputErrorColor;
  } else if (type === 'success') {
    return theme.tokens.ComponentTextInputBorderSuccessColor;
  } else {
    return theme.tokens.ComponentTextInputMessageFontColor;
  }
};
export const messageBlockDefaultStyle = theme => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '4px'
});
export const messageDefaultStyle = (theme, size, state) => ({
  color: resolveColor(state, theme),
  lineHeight: '115%',
  fontFamily: theme.tokens.ComponentTextInputFontFamily,
  fontSize: resolveLabelFontSize(theme, size),
  fontWeight: theme.tokens.ComponentTextInputMessageFontWeight
});